import { LightConfigDto } from '../../../trillion-common/src/dto/light-config.dto'

export const DEFAULT_LIGHTS_CONFIG: LightConfigDto[] = [
  {
    name: 'Directional light',
    type: 'DirectionalLight',
    intensity: 5,
    position: {
      x: 0.3840190404908146,
      y: 2,
      z: -0.7869040995338393,
    },
    color: 16777215,
    target: {
      x: 0.2961880639419163,
      y: 0,
      z: 1.0606878928481889,
    },
  },
  {
    name: 'Point light',
    type: 'PointLight',
    intensity: 0.8639667705088266,
    position: {
      x: 0,
      y: 1.1582438955529066,
      z: 0.03314857144418651,
    },
    color: 16777215,
  },
]
